interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const buttonBase =
  "flex items-center justify-center min-w-[36px] h-9 px-3 rounded-md text-sm transition-colors cursor-pointer";

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    pages.push(i);
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 pt-8">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${buttonBase} border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        <span className="ml-1 hidden sm:inline">上一页</span>
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`${buttonBase} ${
            item === page
              ? "bg-primary-500 text-background-50 font-medium"
              : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${buttonBase} border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="mr-1 hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </div>
  );
}